import { createRootRouteWithContext, HeadContent, Outlet } from "@tanstack/react-router";
import { useSessionSync } from "../hooks/use-session-sync";
import { useDirection } from "../hooks/use-direction";
import { useLanguageTransition } from "../hooks/use-language-transition";

import type { RouterContext } from "../router";

export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({
    meta: [
      { title: "brinked.ai" },
      {
        name: "description",
        content: "brinked.ai - AI learning platform",
      },
    ],
  }),
  component: RootLayout,
});

function RootLayout() {
  useDirection();
  useSessionSync();
  const isLangTransitioning = useLanguageTransition(400);
  const { isPending } = Route.useRouteContext();

  if (isPending) {
    return (
      <>
        <HeadContent />
        <div className="min-h-screen bg-background flex items-center justify-center">
          <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
        </div>
      </>
    );
  }

  return (
    <>
      <HeadContent />
      {isLangTransitioning ? (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-background/80 backdrop-blur-sm transition-opacity duration-300">
          <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
        </div>
      ) : null}
      <Outlet />
    </>
  );
}
